{
  "currentBid": "目前出價",
  "startingBid": "起標價",
  "startingPrice": "起標價",
  "buyNow": "立即購買",
  "buyNowUnavailable": "已有人出價，「立即購買」不再適用。",
  "reserveMet": "已達底價",
  "reserveNotMet": "未達底價",
  "reserveNotMetTitle": "未達底價",
  "reserveNotMetBody": "最高出價未達賣家設定的底價，因此沒有得標者，亦不會建立訂單。",
  "noReserve": "沒有底價",
  "reservePrice": "底價",
  "minimumIncrement": "最低加價幅度",
  "minimumBid": "最低出價為 {amount}",
  "yourBid": "你的出價（最低 {amount}）",
  "endsIn": "距離拍賣結束",
  "timeRemaining": "剩餘時間",
  "auctionEnds": "拍賣結束時間",
  "ended": "已結束",
  "auctionEnded": "此拍賣已結束。",
  "auctionEndedSold": "此拍賣已結束並已售出。",
  "youWon": "🎉 你已成功得標！",
  "autoExtendEnabled": "已啟用自動延長",
  "autoExtended": "拍賣已延長 {seconds} 秒",
  "placeBid": "出價",
  "signInToBid": "登入後出價",
  "ownAuction": "你不能對自己的拍賣出價。",
  "biddingPaused": "另一位買家正在完成「立即購買」結帳，出價將暫停最多 10 分鐘。",
  "bidHistory": "出價紀錄",
  "winningBid": "得標價",
  "highestBidder": "最高出價者",
  "youAreWinning": "你目前是最高出價者",
  "outbid": "已被超越",
  "sold": "已售出",
  "paymentPending": "等待付款",
  "payNow": "立即付款",
  "preparingPayment": "正在準備付款…",
  "preparePayment": "準備付款",
  "viewOrder": "查看訂單",
  "loadingOrder": "正在載入你的訂單…",
  "disputeHold": "此訂單有爭議處理中，付款已暫停。",
  "promoteListing": "推廣此拍賣",
  "bids": "{count} 次出價",
  "watchers": "{count} 人追蹤",
  "yourMaxBid": "你的最高出價",
  "bidPlaced": "已成功出價",
  "invalidAmount": "請輸入有效金額",
  "bidTooLow": "出價須至少為 {amount}。",
  "shipping": "寄送",
  "collection": "自取",
  "payment": "付款",
  "seller": "賣家",
  "buyer": "買家",
  "condition": "狀況",
  "grade": "評級",
  "population": "鑑定數量統計",
  "certificateNumber": "鑑定編號",
  "watchlist": "追蹤清單",
  "addToWatchlist": "加入追蹤清單",
  "removeFromWatchlist": "從追蹤清單移除"
}
